import { memo, FC } from "react";
import { useSectionNavigationContext } from "../section-navigation-context";
import { SectionNavigationListItemProps } from "./interfaces";

const SectionNavigationListItem: FC<SectionNavigationListItemProps> = ({
  children,
  hasSubsections = true,
  childListIndex = "",
  id,
  ...rest
}) => {
  const { getListItemProps } = useSectionNavigationContext();

  if (!getListItemProps) {
    throw new Error(
      "SectionNavigation.ListItem component requires getListItemProps to be defined",
    );
  }

  return (
    <li {...getListItemProps({ hasSubsections, id, childListIndex, ...rest })}>
      {children}
    </li>
  );
};

export default memo(SectionNavigationListItem);
